import { render, staticRenderFns } from "./cadastro_edicao_atendente.vue?vue&type=template&id=52704e35&scoped=true"
import script from "./cadastro_edicao_atendente.vue?vue&type=script&lang=js"
export * from "./cadastro_edicao_atendente.vue?vue&type=script&lang=js"
import style0 from "./cadastro_edicao_atendente.vue?vue&type=style&index=0&id=52704e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52704e35",
  null
  
)

export default component.exports